import { useEffect, useRef } from 'react';

export const useFieldVisibilityValueManager = (isVisible, fieldName, form, defaultValue) => {
  // Used to store and track the state of visibility of a field
  const prevVisibleRef = useRef(isVisible);
  // Used to store and track the local value of a field when alternating between visible and hidden
  const lastValidValueRef = useRef(defaultValue);

  useEffect(() => {
    // If the field has no current value we set the defaultValue provided by the mapping
    if (isVisible) {
      const current = form.getFieldValue(fieldName);
      if (current === undefined && defaultValue !== undefined) {
        form.setFieldValue(fieldName, defaultValue);
      }
    }

    // If it was visible and not it's hidden set it to null to filter on the onSubmit based on null values
    if (!isVisible && prevVisibleRef.current) {
      const current = form.getFieldValue(fieldName);
      if (current !== null && current !== undefined) {
        lastValidValueRef.current = current;
      }
      form.setFieldValue(fieldName, null);
    }

    // If it was hidden and now gets visible either restore the previous set value locally or it's default
    // if it doesnt have a local stored value

    if (isVisible && !prevVisibleRef.current) {
      const restore = lastValidValueRef.current !== undefined ? lastValidValueRef.current : defaultValue;
      const current = form.getFieldValue(fieldName);
      if (current === undefined || current === null) {
        form.setFieldValue(fieldName, restore);
      }
    }

    prevVisibleRef.current = isVisible;
  }, [isVisible, defaultValue, fieldName, form]);
};
